import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../general/base/base.component';
import { OverlayPanelComponent } from '../overlay-panel/overlay-panel.component';
import { Site24Monitor } from './monitor.definitions';
import { MonitorService } from './monitor.service';
import { AppStabilityService } from '../../shared/app-stability.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { _ } from '~shared/utils';

@Component({
  selector: 'qm-monitors',
  templateUrl: './monitors.component.html',
  styleUrls: ['./monitors.component.scss']
})
export class MonitorsComponent extends BaseComponent implements OnInit, OnDestroy {

  @ViewChild('overlay', { static: true })
  public overlay: OverlayPanelComponent;

  public tenantsMonitors: Site24Monitor;
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private readonly ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly monitorService: MonitorService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly appStability: AppStabilityService) {
    super();
    this.name = 'MonitorsComponent';
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    const init = () => {
      this.monitorService.monitors$.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data) => {
          this.tenantsMonitors = data;
          this.changeDetectorRef.markForCheck();
        });
    };

    this.appStability.whenFirstStable().then(() => {
      console.log('App is stable, initializing monitors component');
      init();
    });
  }

  /**
   * Found at least three statuses from site24 to show on tooltip..
   * @param status site24 status as number
   */
  public site24StatusAsString(status: number): string {
    switch (status) {
      case 0:
        return _('down');
      case 1:
        return _('up');
      case 2:
        return _('warning');
    }
  }

  /**
   * mask all statuses to DOWN (false/red) or UP (true/green) in that order.
   */
  public site24MainStatusUp(): boolean {
    if (this.tenantsMonitors?.monitorList.some( item => item.status === 0 || item.status === 2)) {
      return false;
    } else {
      return true;
    }
  }
}
